"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5301],{

/***/ 85301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPaqueteCircle = function SvgPaqueteCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.96 5.81s-.03.02-.04.04-.02.04-.03.05 0 0 0 .01v4.01c0 .07.04.13.1.16l3.96 2.03h.01c.02 0 .05.01.07.01s.05 0 .07-.02h.01l3.96-2.03c.06-.03.1-.09.1-.16V5.89s-.02-.03-.03-.05l-.01-.01a.138.138 0 0 0-.04-.03h-.02L8.11 3.86a.195.195 0 0 0-.15 0L3.99 5.79Zm7.82 4.01-3.61 1.85V8.11l3.61-1.85v3.56ZM4.22 6.26l1.06.54v1.67c0 .07.04.13.09.16l1.18.62s.05.02.08.02.06 0 .09-.02c.05-.03.09-.09.09-.15V7.6l1.02.52v3.56L4.22 9.83V6.27Zm1.41.72.83.42v1.39l-.83-.43V6.97ZM8 4.24l3.57 1.74L8 7.81l-1.01-.52 1.08-.55c.06-.03.1-.09.1-.16s-.03-.13-.09-.16l-1.14-.6a.153.153 0 0 0-.16 0l-1.33.67-1.01-.52 3.57-1.74ZM5.84 6.69l1.02-.52.76.4-1.01.51-.77-.39Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "#025754"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 15.57A7.571 7.571 0 0 0 8 .43a7.571 7.571 0 0 0 0 15.14ZM8 16c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Z",
    style: {
      fillRule: "evenodd",
      fill: "#025754"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgPaqueteCircle);

/***/ })

}]);